export const ErrorCode = {
    EMAIL_IN_USE: 100,
    UNKNOWN_SERVER_ERROR: 101,
    INVALID_TOKEN: 102,
    INVALID_LOGIN_ATTEMPT: 103,
    UNAUTHORIZED: 104,
    INVALID_RESET_TOKEN: 105
}

export const USER_KEY = "THSBGDYDPKDH1552NC";

export const Role = {
    ADMIN: "Admin",
    APPLICANT: "Applicant",
    REVIEWER: "Reviewer",
    PAYROLL: "Payroll",
    SALESREP: "SalesRep",
    SALESMANAGER: "SalesManager"
}

export const Language = {
    ENGLISH: "English",
    SPANISH: "Spanish",
    EN : "EN", 
    SP : "SP"
}

export const TrainingStatus = {
    PENDING: "Pending",
    INPROGRESS: "In-Progress",
    COMPLETED: "Completed"
}

export const TrainingResult = {
    UNKNOWN: "Unknown",
    FAILED: "Failed",
    PASSED: "Passed"
}

export const Operation = {
    CREATED: 0,
    UPDATED: 1,
    DELETED: 2
}